import { Relationship } from 'json-api';
import { AtomResource } from '../../core/classes/atom-resource';
import { PaymentDimension } from '../resources/payment-dimension.resource';
import { Constructor } from './constructor.type';

export interface ResourceWithPaymentDimensions extends AtomResource {
  paymentdimensions?: PaymentDimension[];
  ownedPaymentDimensions?: PaymentDimension[];
  inheritedPaymentDimensions?: PaymentDimension[];
  canAddPaymentDimensions: boolean;
}

export type HasPaymentDimensions = Constructor<ResourceWithPaymentDimensions>;

export function WithPaymentDimensions<T extends Constructor<AtomResource>>(
  Base: T
): HasPaymentDimensions & T {
  class WithPaymentDimensionsClass extends Base {
    @Relationship() paymentdimensions?: PaymentDimension[];

    get ownedPaymentDimensions(): PaymentDimension[] | undefined {
      return this.paymentdimensions?.filter((dimension) =>
        dimension.isAssociatedAt(this)
      );
    }

    get inheritedPaymentDimensions(): PaymentDimension[] | undefined {
      return this.paymentdimensions?.filter(
        (dimension) => !dimension.isAssociatedAt(this)
      );
    }

    get canAddPaymentDimensions(): boolean {
      return this.type === 'contracts';
    }
  }
  return WithPaymentDimensionsClass;
}
